import { render } from "./contactFirst.vue?vue&type=template&id=69a24768&scoped=true"
import script from "./contactFirst.vue?vue&type=script&lang=js"
export * from "./contactFirst.vue?vue&type=script&lang=js"

import "./contactFirst.vue?vue&type=style&index=0&id=69a24768&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a24768"]])

export default __exports__